const uz = {
    meta: {
        title: "Sun'iy intellektni biznesga joriy etish — narx va qaytim",
        description:
            "Sun'iy intellektni biznesga joriy etish: uchta arzon boshlanish nuqtasi, narx 18 mln so'mdan, qaytim hisobi, xavflar va davlat qoplaydigan 50 foiz dastur.",
        keywords: [
            "sun'iy intellektni biznesga joriy etish",
            "AI kichik biznes uchun",
            "sun'iy intellekt joriy etish narxi",
            "AI loyihasi qanday boshlanadi",
            "AI xarajatlarini qoplash dasturi",
            "AI hamkor dasturi",
            "PP-358 sun'iy intellekt strategiyasi",
        ],
    },
    h1: "AI'ni kichik biznesga joriy etish: nimadan boshlash, qancha turadi, davlat nimani qoplaydi",
    lead:
        "Sun'iy intellekt endi taqdimot slaydi emas — u byudjet satri. Bu maqolada AI loyihasi qanchaga tushishini, qaysi uchta vazifadan boshlash eng arzon ekanini va davlat dasturi xarajatning yarmini qanday qoplashini raqamlar bilan ko'rib chiqamiz. Shu bilan birga AI qaysi holatda umuman kerak emasligini ham ochiq aytamiz.",
    category: "Sun'iy intellekt",
    readingTime: "11 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Rahbarlar bilan suhbat odatda bir xil savoldan boshlanadi: AI bizga nima beradi? Unga javob berish uchun avval boshqa uchta raqamni bilish kerak — kompaniyada qaysi ish har kuni takrorlanadi, unga oyiga necha soat ketadi va bitta xatoning narxi qancha. Shu uch raqamsiz AI loyihasi taxminga aylanadi.",
        },

        { type: "h2", text: "AI loyihasi nimadan boshlanadi — modeldan emas, ma'lumotdan" },
        {
            type: "p",
            text:
                "Sun'iy intellekt model o'zidan bilim ixtiro qilmaydi. U faqat siz bergan ma'lumot ustida ishlaydi va shu ma'lumotning sifati natijani belgilaydi. Shuning uchun har bir loyiha modelni tanlashdan emas, ma'lumotni yig'ish va tartibga solishdan boshlanadi.",
        },
        {
            type: "p",
            text:
                "Amaliyotdagi eng ko'p uchraydigan to'siq — ma'lumotning tarqoqligi. Narxlar Excel'ning besh xil versiyasida yotadi, shartnomalar pochtada, buyurtmalar esa Telegram yozishmasida qolib ketadi. Bunday holatda model ham xato javob beradi va aybdor texnologiya emas, tartib bo'ladi.",
        },
        {
            type: "p",
            text:
                "Ma'lumot hajmi bo'yicha oddiy mo'ljal bor. Matn bilan ishlaydigan yechim uchun 300–500 ta hujjat yoki bilimlar bazasi sahifasi yetarli bo'ladi. Raqam bilan ishlaydigan bashorat modeli uchun esa kamida 12–24 oylik tarix kerak, aks holda model mavsumiylikni ko'rmaydi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Davlat AI xarajatining qanchasini qoplaydi?" },
        {
            type: "p",
            text:
                "Sun'iy intellekt texnologiyalarini 2030-yilgacha rivojlantirish strategiyasi PP-358 qarori bilan 2024-yil 14-oktyabrda tasdiqlangan. Hujjat maqsadlari orasida AI asosidagi dasturiy mahsulot va xizmatlar hajmini 1,5 mlrd dollarga yetkazish hamda davlat xizmatlarining 10 foizini AI asosiga o'tkazish bor.",
        },
        {
            type: "p",
            text:
                "Biznes uchun muhimi — pul. Davlat byudjetida AI joriy etishga har yili 100 mlrd so'm ko'zda tutilgan, 2025–2026 yillar uchun esa 60 dan ortiq loyihadan iborat ro'yxat tasdiqlangan. Bu shuni anglatadiki, AI mavzusi bir yillik kampaniya emas, uzoq muddatli davlat yo'nalishi.",
        },
        {
            type: "p",
            text:
                "Eng to'g'ridan-to'g'ri ta'sir qiladigan qarori esa boshqa: 10 000 korxona uchun AI-hamkor dasturi e'lon qilindi va unda bizneslarga sun'iy intellekt joriy etish xarajatlarining 50 foizi qoplab beriladi. Ya'ni 18 mln so'mlik pilot loyihaning yarmi kompaniya zimmasidan tushishi mumkin.",
        },
        {
            type: "callout",
            text:
                "Muhim ogohlantirish: dastur shartlari, ariza berish tartibi va qoplash chegarasi vaqt o'tishi bilan aniqlashtiriladi. Byudjetni faqat kompensatsiyaga tayanib tuzmang — loyiha to'liq narxda ham o'zini oqlashi kerak. Kompensatsiya bonus bo'lsin, asos emas.",
        },
        {
            type: "p",
            text:
                "Bozor tayyorligi haqida ham raqam bor. KPMG Tech Report 2026 so'rovida Markaziy Osiyodagi 70 dan ortiq korxona qatnashgan va sanoat kompaniyalarining 53 foizi AI texnologiyalarini o'lchanadigan samara bilan ishlatishini ko'rsatgan. Global ko'rsatkich esa 24 foiz. Boshqacha aytganda, mintaqada AI allaqachon tajriba bosqichidan chiqqan.",
        },

        { type: "h2", text: "Uchta arzon boshlanish nuqtasi" },
        {
            type: "p",
            text:
                "AI loyihasini butun kompaniya bo'ylab boshlash shart emas va zarar ham. Amaliyotda eng tez qaytim beradigan uchta vazifa bor — ular arzon, tez o'lchanadi va ishlamasa yo'qotish cheklangan bo'ladi.",
        },
        { type: "h3", text: "1. Hujjat va ariza matnini avtomatik tahlil qilish" },
        {
            type: "p",
            text:
                "Shartnoma, hisob-faktura, akt, tender hujjati yoki kiruvchi ariza — bularning hammasi matn. Model matndan kerakli maydonlarni ajratadi, hujjatni turkumlaydi va xodimga tayyor xulosa beradi. Yuridik bo'lim yoki buxgalteriya kuniga 40–60 hujjat ko'radigan joyda bu bir necha soatni bo'shatadi.",
        },
        { type: "h3", text: "2. Mijozning takrorlanuvchi savollarini yopish" },
        {
            type: "p",
            text:
                "Katalog, narx, ish vaqti, yetkazib berish shartlari va buyurtma holati — bu savollar har kuni takrorlanadi. Ularni bilimlar bazasiga ulangan agent javob berishi mumkin. Bu mavzuni alohida maqolada batafsil ochganmiz, chunki bu yerda eng katta xato — botga ortiqcha vazifa yuklash.",
        },
        { type: "h3", text: "3. Bashorat: qoldiq, talab va lid skoring" },
        {
            type: "p",
            text:
                "Bu yerda katta til modeli emas, klassik mashinali o'qitish ishlatiladi. Model sotuv tarixi asosida keyingi oy talabini, ombor qoldig'ini yoki qaysi lid xarid qilish ehtimoli yuqori ekanini baholaydi. Natija foizda o'lchanadi va uni tekshirish oson: bashoratni real natija bilan solishtirasiz.",
        },
        { type: "image", image: 1 },
        {
            type: "table",
            head: ["Boshlanish nuqtasi", "Kerakli ma'lumot", "Muddat", "Byudjet oralig'i"],
            rows: [
                [
                    "Hujjat va ariza tahlili",
                    "300–500 hujjat yoki sahifa",
                    "3–4 hafta",
                    "18 mln so'mdan",
                ],
                [
                    "Takrorlanuvchi savollarni yopish",
                    "Bilimlar bazasi, 100–300 sahifa",
                    "3–4 hafta",
                    "15 mln so'mdan",
                ],
                [
                    "Bashorat: qoldiq, talab, lid skoring",
                    "12–24 oylik sotuv tarixi",
                    "6–10 hafta",
                    "45 mln so'mdan",
                ],
                [
                    "Mavjud CRM yoki 1C'ga AI ulash",
                    "Tizimda tartiblangan ma'lumot",
                    "4–8 hafta",
                    "25 mln so'mdan",
                ],
            ],
        },

        { type: "h2", text: "AI joriy etish qancha turadi?" },
        {
            type: "p",
            text:
                "Narx ikki qismdan iborat va ularni aralashtirib yuborish eng ko'p uchraydigan byudjet xatosi. Birinchisi — ishlab chiqish, u bir marta to'lanadi. Ikkinchisi — model API'sining oylik xarajati, u so'rovlar soniga bog'liq va to'g'ridan-to'g'ri provayderga to'lanadi.",
        },
        {
            type: "table",
            head: ["Yechim", "Bir martalik narx", "Muddat", "Oylik API xarajati"],
            rows: [
                ["AI pilot (bitta vazifa)", "18 mln so'mdan", "3–4 hafta", "300 000 – 1,2 mln so'm"],
                ["AI standart (ishlab chiqarishga tayyor)", "45 mln so'mdan", "6–10 hafta", "1,5–4 mln so'm"],
                ["AI agent (mijoz bilan muloqot)", "15 mln so'mdan", "3–4 hafta", "250 000 – 900 000 so'm"],
                ["Mavjud tizimga AI integratsiya", "25 mln so'mdan", "4–8 hafta", "1–10 mln so'm"],
                ["Computer vision pilot", "45 mln so'mdan", "6–8 hafta", "server va kamera alohida"],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan narsalarni oldindan bilib qo'ying. Model API to'lovi alohida va oylik. Computer vision loyihalarida kamera, server yoki edge qurilma qiymati alohida sotib olinadi. Yopiq konturda o'z serveringizdagi model ishlatilsa, API to'lovi bo'lmaydi, lekin uskuna va uni saqlash xarajati paydo bo'ladi.",
        },

        { type: "h2", text: "Qaytim qanday hisoblanadi — ochiq formula" },
        {
            type: "p",
            text:
                "AI loyihasining qaytimi ikki manbadan keladi: tejalgan vaqt va yo'qotilmagan pul. Ikkalasini ham oldindan hisoblash mumkin, faqat o'z raqamlaringizni qo'yishingiz kerak.",
        },
        {
            type: "ol",
            items: [
                "Vazifa oyiga necha marta takrorlanadi? Masalan, kiruvchi hujjat — oyiga 900 ta.",
                "Bittasiga qancha vaqt ketadi? Masalan, 6 daqiqa — bu oyiga 90 soat.",
                "Bir soat xodim vaqti qancha turadi? Ish haqi va soliqni qo'shib, masalan 45 000 so'm.",
                "Model vazifaning qancha qismini yopadi? Realistik mo'ljal — 60–75 foiz, 100 foiz emas.",
                "Tejalgan pulni hisoblang: 90 soat × 45 000 so'm × 0,65 = oyiga taxminan 2,6 mln so'm.",
            ],
        },
        {
            type: "p",
            text:
                "Shu misolda oylik API xarajati 800 000 so'm bo'lsa, sof tejamkorlik oyiga 1,8 mln so'm. 18 mln so'mlik pilot taxminan 10 oyda o'zini oqlaydi. Agar davlat dasturi orqali xarajatning yarmi qoplansa, bu muddat 5 oyga tushadi.",
        },
        {
            type: "p",
            text:
                "Ikkinchi manba — yo'qotilmagan pul. Bu javob kechikkani uchun ketgan mijoz, hujjatdagi xato tufayli to'langan jarima yoki noto'g'ri bashorat sababli omborda qotib qolgan tovar. Bu raqamlar odatda tejalgan vaqtdan kattaroq bo'ladi, lekin ularni o'lchash uchun avvalgi yil statistikasi kerak.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Hech narsa qilmaslikning narxi" },
        {
            type: "p",
            text:
                "AI'ni kechiktirishning narxi darhol ko'rinmaydi, chunki u hisobvaraqda alohida satr bo'lib turmaydi. Lekin u bor va odatda quyidagi ko'rinishda yig'iladi.",
        },
        {
            type: "list",
            items: [
                "Malakali xodim kuniga uch-to'rt soatini nusxa ko'chirish va qidirishga sarflaydi — bu to'lanayotgan, lekin qiymat yaratmaydigan vaqt.",
                "Kiruvchi murojaatning bir qismi javobsiz qoladi yoki kech javob oladi; mijoz raqobatchiga ketadi va buni hech kim sanamaydi.",
                "Qaror tarixiy his-tuyg'u bilan qabul qilinadi: qancha tovar olish, qaysi lidga vaqt sarflash — bu yerda xato narxi to'g'ridan-to'g'ri marjadan yeyiladi.",
                "Davlat qo'llab-quvvatlash dasturlari muddatli bo'ladi; kech qolgan kompaniya keyin to'liq narxda joriy etadi.",
            ],
        },

        { type: "h2", text: "Xavflar: gallyutsinatsiya, aniqlik va oylik hisob" },
        {
            type: "p",
            text:
                "AI haqida halol gapirish kerak, aks holda birinchi muvaffaqiyatsizlik butun yo'nalishga ishonchni yo'qotadi. Til modellari gallyutsinatsiya qiladi — ya'ni ishonchli ohangda noto'g'ri javob berishi mumkin. Bu texnologiyaning nuqsoni emas, uning tabiati.",
        },
        {
            type: "list",
            items: [
                "Gallyutsinatsiyaga qarshi asosiy usul — javobni faqat sizning hujjatlaringizdan olish va har javobda manba hujjat hamda sahifa raqamini ko'rsatish. Manba yo'q javob ko'rsatilmasligi kerak.",
                "Computer vision'da 100 foiz aniqlik bo'lmaydi. Yaxshi yoritilgan va to'g'ri burchakdagi kamerada bu odatda 90–97 foiz, murakkab sharoitda — qorong'ilik, obyektlar bir-birini to'sganda — 75–90 foizgacha tushadi.",
                "Oylik API xarajati so'rovlar soniga bog'liq va u o'sishi mumkin. Tizimga sarf limiti va ogohlantirish qo'yilishi shart, aks holda hisob kutilmaganda oshadi.",
                "Shaxsiy ma'lumot bulut modeliga yuborilmasligi kerak. Yoki maskalash qo'llaniladi, yoki model o'z serveringizda ishlaydi.",
                "Sharoit o'zgarsa, model sifati pasayadi: yangi qadoq turi, kamera burchagining siljishi, assortiment yangilanishi. Shuning uchun qayta o'qitish oldindan rejalashtiriladi.",
            ],
        },
        {
            type: "p",
            text:
                "Alohida aytish kerak: AI xodimni to'liq almashtirmaydi. U takrorlanuvchi qismni oladi, qaror esa odamda qoladi. Yuridik xulosa, moliyaviy tasdiq va mijoz bilan nizoli suhbat — bularning hammasi javobgarlik talab qiladi va javobgarlikni modelga yuklab bo'lmaydi.",
        },

        { type: "h2", text: "Qachon AI kerak emas" },
        {
            type: "p",
            text:
                "Bu band maqolaning eng foydali qismi bo'lishi mumkin. Quyidagi holatlarda AI loyihasini boshlamang — pul sarflanadi, natija chiqmaydi.",
        },
        {
            type: "list",
            items: [
                "Ma'lumot yo'q yoki u tizimlashtirilmagan. Avval CRM yoki ombor hisobini yo'lga qo'ying, keyin AI haqida o'ylang.",
                "Vazifa takrorlanmaydi. Oyiga besh marta bajariladigan ish uchun avtomatlashtirish qimmat turadi.",
                "Jarayonning o'zi buzuq. Tartibsiz jarayonni avtomatlashtirish tartibsizlikni tezlashtiradi, tuzatmaydi.",
                "Xato narxi juda yuqori va tekshiruv mexanizmi yo'q. Tibbiy tashxis yoki yakuniy yuridik xulosa bunga misol.",
                "Byudjet faqat bir martalik to'lovga yetadi. Oylik API xarajati va qo'llab-quvvatlash uchun mablag' bo'lmasa, tizim ikki-uch oyda to'xtaydi.",
            ],
        },

        { type: "h2", text: "Birinchi 90 kun: amaliy qadamlar" },
        {
            type: "ol",
            items: [
                "Bitta vazifani tanlang — eng ko'p takrorlanadigan va eng oson o'lchanadigan ishni. Uchtasini birdan olmang.",
                "Hozirgi ko'rsatkichni yozib oling: oyiga necha marta, qancha vaqt, qancha xato. Bu bazaviy raqam bo'ladi.",
                "Ma'lumotni yig'ing va tartibga soling. Bu bosqich eng ko'p vaqt oladi va natijani aynan u belgilaydi.",
                "3–4 haftalik pilot qiling. Muvaffaqiyat mezonini oldindan yozing: masalan, savollarning 60 foizi odamsiz yopilsin.",
                "O'lchang va solishtiring. Pilot mezonga yetmasa, to'xtating — yo'qotish 18 mln so'm bilan cheklanadi, yuzlab million emas.",
                "Natija bo'lsa, kengaytiring va davlat qoplash dasturi shartlarini o'sha paytdagi rasmiy manbadan tekshiring.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "quote",
            text:
                "AI loyihasi model tanlashdan emas, bitta o'lchanadigan vazifadan boshlanadi. O'lchanmaydigan foyda foyda emas.",
        },
    ],

    faq: [
        {
            q: "Sun'iy intellektni joriy etish O'zbekistonda qancha turadi?",
            a: "Innobek'da AI pilot 18 000 000 so'mdan boshlanadi — bu bitta vazifani hal qiladigan va 500 tagacha hujjat bilan ishlaydigan versiya. Ishlab chiqarishga tayyor standart paket 45 000 000 so'mdan. Mijoz bilan muloqot qiladigan AI agent 15 000 000 so'mdan, mavjud CRM yoki 1C'ga ulash esa 25 000 000 so'mdan. Bu bir martalik to'lov, model API'si alohida hisoblanadi.",
        },
        {
            q: "Oylik xarajat qancha bo'ladi va u nimadan iborat?",
            a: "Oylik xarajatning asosiy qismi — model API to'lovi va u so'rovlar soniga bog'liq. Kichik hajmda, ya'ni kuniga 200–500 so'rovda, bu taxminan 300 000 – 1 200 000 so'm. O'rtacha hajmda 1 500 000 – 4 000 000 so'm atrofida bo'ladi. Pul to'g'ridan-to'g'ri provayderga to'lanadi. Pilot bosqichida real hajm o'lchanadi va aniq raqam beriladi.",
        },
        {
            q: "Davlat AI joriy etish xarajatini haqiqatan qoplaydimi?",
            a: "10 000 korxona uchun AI-hamkor dasturi doirasida bizneslarga sun'iy intellekt joriy etish xarajatlarining 50 foizi qoplab berilishi e'lon qilingan. Bundan tashqari davlat byudjetida AI yo'nalishiga har yili 100 mlrd so'm ko'zda tutilgan. Lekin dastur shartlari va ariza tartibi vaqt o'tishi bilan aniqlashtiriladi — byudjetni kompensatsiyaga emas, loyihaning o'z qaytimiga qurish to'g'riroq.",
        },
        {
            q: "AI loyihasi qancha vaqtda o'zini oqlaydi?",
            a: "Bu takrorlanish chastotasiga bog'liq. Oyiga 900 ta hujjat ko'riladigan va bittasiga 6 daqiqa ketadigan jarayonda pilot odatda 8–12 oyda nolga chiqadi. Davlat dasturi orqali yarmi qoplansa, muddat ikki barobar qisqaradi. Takrorlanish kam bo'lsa, qaytim cho'ziladi. Universal muddat yo'q — maqoladagi besh qadamli formulaga o'z raqamlaringizni qo'ying.",
        },
        {
            q: "AI noto'g'ri javob bersa nima bo'ladi?",
            a: "Til modellari gallyutsinatsiya qiladi, ya'ni ishonchli ohangda xato javob berishi mumkin. Buning oldini olishning asosiy usuli — modelga faqat sizning hujjatlaringizdan javob berishga ruxsat berish va har javobda manba hujjat hamda sahifa raqamini ko'rsatish. Manba topilmasa, tizim javob o'rniga odamga uzatadi. Javobgarlik talab qiladigan qarorlar baribir odamda qoladi.",
        },
        {
            q: "Qachon AI kerak emas?",
            a: "Ma'lumot yig'ilmagan yoki tizimlashtirilmagan bo'lsa, avval hisob-kitobni yo'lga qo'ying. Vazifa oyiga bir necha marta bajarilsa, avtomatlashtirish qimmatga tushadi. Jarayonning o'zi buzuq bo'lsa, AI tartibsizlikni tezlashtiradi. Xato narxi juda yuqori va tekshiruv mexanizmi bo'lmasa ham boshlamang. Byudjet faqat bir martalik to'lovga yetsa, tizim bir necha oydan keyin to'xtaydi.",
        },
        {
            q: "Ma'lumotlarim modelga yuborilsa, ular maxfiy qoladimi?",
            a: "Bu savolni loyiha boshida hal qilish kerak. Uch variant bor: shaxsiy ma'lumotlarni modelga yuborishdan oldin maskalash, faqat maxfiy bo'lmagan qismni bulutga chiqarish yoki modelni butunlay o'z serveringizda ishlatish. Uchinchi variantda API to'lovi bo'lmaydi, lekin uskuna va uni saqlash xarajati paydo bo'ladi. Audit jurnali har uch holatda ham zarur.",
        },
    ],

    cta: {
        h: "AI sizga foyda beradimi — bepul aniqlaymiz",
        p:
            "Jarayonlaringizni ko'rib chiqamiz, AI real natija beradigan bitta vazifani ko'rsatamiz va bermaydigan joyini ham ochiq aytamiz. Keyin aniq narx, muddat va taxminiy oylik xarajatni beramiz.",
        button: "Konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/ai-joriy-etish-cover.webp",
            alt: "Kichik biznes rahbari AI yordamchisi umumlashtirgan arizalar ro'yxatini noutbukda ko'rmoqda",
            caption: "AI loyihasi katta byudjetdan emas, bitta o'lchanadigan vazifadan boshlanadi",
            prompt:
                "Small-business owner at a laptop where an AI assistant panel summarises incoming orders and flags three priorities; warm realistic office scene, subtle blue glow from the screen, documentary photography style, no readable text or logos, 16:9",
        },
        {
            src: "/assets/img/blog/ai-joriy-etish-kirish-nuqtalari.webp",
            alt: "AI'ni joriy etishning uchta arzon boshlanish nuqtasi kartochkalar ko'rinishida",
            caption: "Uchta kirish nuqtasi: hujjat tahlili, takroriy savollar va bashorat",
            prompt:
                "Three entry-point cards for AI adoption: document and request parsing, repetitive customer questions, forecasting (stock, demand, lead scoring); each card shows required data volume, typical timeline and budget band as blank meter bars; clean flat cards, blue and violet accents, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/ai-joriy-etish-tayyorgarlik.webp",
            alt: "AI loyihasining tayyorgarlik voronkasi: ma'lumot, tozalash, pilot, o'lchov va masshtab",
            caption: "Eng ko'p uchraydigan xato ma'lumotni tozalash bosqichida sodir bo'ladi",
            prompt:
                "Readiness funnel diagram: data collected to data cleaned to pilot on one process to measurement to scale; each stage narrowing, with a warning marker at the data-cleaning stage; minimal line infographic, blue gradient with one amber marker, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/projects/neurotagline.webp",
            alt: "Neurotagline loyihasi — sun'iy intellekt asosidagi mahsulot interfeysi ekranda",
            caption: "Neurotagline — Innobek portfelidagi AI yo'nalishi bo'yicha loyiha",
        },
    ],

    relatedServices: ["sun-iy-intellekt", "ai-integratsiya", "ai-agent"],
    relatedPosts: ["ai-chatbot-yoki-jonli-operator", "computer-vision-ombor-va-dokonda"],
};

const ru = {
    meta: {
        title: "Внедрение искусственного интеллекта в бизнесе — цена",
        description:
            "Внедрение ИИ в малом бизнесе: три недорогие точки входа, цена от 18 млн сум, расчёт окупаемости, риски и программа, где государство компенсирует 50% расходов.",
        keywords: [
            "внедрение искусственного интеллекта в бизнесе Узбекистан",
            "ИИ для малого бизнеса Узбекистан",
            "стоимость внедрения ИИ",
            "компенсация расходов на ИИ",
            "с чего начать AI-проект",
            "программа ИИ-партнёр для предприятий",
            "стратегия искусственного интеллекта ПП-358",
        ],
    },
    h1: "Внедрение ИИ в малом бизнесе: с чего начать, сколько стоит и что компенсирует государство",
    lead:
        "Искусственный интеллект перестал быть слайдом в презентации — теперь это строка бюджета. Разбираем на цифрах, сколько стоит AI-проект, какие три задачи дешевле всего брать первыми и как государственная программа покрывает половину расходов. И отдельно — когда ИИ вам не нужен вовсе.",
    category: "Искусственный интеллект",
    readingTime: "11 минут",

    body: [
        {
            type: "p",
            text:
                "Разговор с руководителем обычно начинается одинаково: что нам даст ИИ? Чтобы ответить, сначала нужны три других числа — какая работа повторяется каждый день, сколько часов в месяц она съедает и во что обходится одна ошибка. Без этих трёх цифр AI-проект превращается в догадку.",
        },

        { type: "h2", text: "AI-проект начинается не с модели, а с данных" },
        {
            type: "p",
            text:
                "Модель не изобретает знания сама. Она работает только на тех данных, которые вы ей дали, и качество этих данных определяет результат. Поэтому любой проект начинается не с выбора модели, а со сбора данных и наведения в них порядка.",
        },
        {
            type: "p",
            text:
                "Самое частое препятствие на практике — разрозненность данных. Цены живут в пяти версиях Excel, договоры лежат в почте, заказы остаются в переписке Telegram. В такой ситуации модель тоже будет ошибаться, и виновата здесь не технология, а порядок учёта.",
        },
        {
            type: "p",
            text:
                "По объёму данных есть простой ориентир. Для решения, работающего с текстом, достаточно 300–500 документов или страниц базы знаний. Для прогнозной модели на числах нужна история минимум за 12–24 месяца, иначе модель просто не увидит сезонность.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Сколько расходов на ИИ компенсирует государство?" },
        {
            type: "p",
            text:
                "Стратегия развития технологий искусственного интеллекта до 2030 года утверждена постановлением ПП-358 от 14 октября 2024 года. Среди её целей — довести объём программных продуктов и услуг на базе ИИ до 1,5 млрд долларов и перевести 10 процентов государственных услуг на технологии ИИ.",
        },
        {
            type: "p",
            text:
                "Для бизнеса важнее деньги. В государственном бюджете на внедрение ИИ заложено 100 млрд сум ежегодно, а на 2025–2026 годы утверждён перечень из более чем 60 проектов. Это значит, что тема ИИ здесь не кампания на один год, а долгосрочный государственный курс.",
        },
        {
            type: "p",
            text:
                "Но сильнее всего на бизнес влияет другое решение: объявлена программа ИИ-партнёр для 10 000 предприятий, в рамках которой компаниям компенсируют 50 процентов расходов на внедрение искусственного интеллекта. То есть из пилота стоимостью 18 млн сум компания может заплатить только половину.",
        },
        {
            type: "callout",
            text:
                "Важная оговорка: условия программы, порядок подачи заявки и предельная сумма компенсации будут уточняться. Не стройте бюджет на одной компенсации — проект должен окупаться и по полной цене. Компенсация пусть будет бонусом, а не основанием для запуска.",
        },
        {
            type: "p",
            text:
                "Есть цифра и по готовности рынка. В опросе KPMG Tech Report 2026 участвовали более 70 предприятий Центральной Азии, и 53 процента промышленных компаний заявили, что используют ИИ с измеримым эффектом. Глобальный показатель — 24 процента. Иначе говоря, в регионе ИИ уже вышел из стадии эксперимента.",
        },

        { type: "h2", text: "Три недорогие точки входа" },
        {
            type: "p",
            text:
                "Начинать AI-проект сразу по всей компании не нужно и даже вредно. На практике быстрее всего окупаются три задачи — они дешёвые, легко измеряются, а если не сработают, потери ограничены.",
        },
        { type: "h3", text: "1. Автоматический разбор документов и заявок" },
        {
            type: "p",
            text:
                "Договор, счёт-фактура, акт, тендерная документация, входящая заявка — всё это текст. Модель вытаскивает из него нужные поля, классифицирует документ и выдаёт сотруднику готовую выжимку. Там, где юристы или бухгалтерия просматривают 40–60 документов в день, это освобождает несколько часов.",
        },
        { type: "h3", text: "2. Закрытие повторяющихся вопросов клиентов" },
        {
            type: "p",
            text:
                "Каталог, цена, часы работы, условия доставки и статус заказа — эти вопросы повторяются ежедневно. На них может отвечать агент, подключённый к базе знаний. Этой теме посвящена отдельная статья, потому что здесь легко совершить главную ошибку — нагрузить бота лишним.",
        },
        { type: "h3", text: "3. Прогноз: остатки, спрос и скоринг лидов" },
        {
            type: "p",
            text:
                "Здесь работает не большая языковая модель, а классическое машинное обучение. Модель по истории продаж оценивает спрос следующего месяца, складские остатки или вероятность покупки конкретного лида. Результат измеряется в процентах, и проверить его просто: сравниваете прогноз с фактом.",
        },
        { type: "image", image: 1 },
        {
            type: "table",
            head: ["Точка входа", "Нужные данные", "Срок", "Диапазон бюджета"],
            rows: [
                ["Разбор документов и заявок", "300–500 документов или страниц", "3–4 недели", "от 18 млн сум"],
                ["Закрытие повторяющихся вопросов", "База знаний, 100–300 страниц", "3–4 недели", "от 15 млн сум"],
                ["Прогноз остатков, спроса, скоринг", "История продаж за 12–24 месяца", "6–10 недель", "от 45 млн сум"],
                ["Подключение ИИ к текущей CRM или 1С", "Упорядоченные данные в системе", "4–8 недель", "от 25 млн сум"],
            ],
        },

        { type: "h2", text: "Сколько стоит внедрение ИИ?" },
        {
            type: "p",
            text:
                "Цена состоит из двух частей, и их смешение — самая частая бюджетная ошибка. Первая часть — разработка, она оплачивается один раз. Вторая — ежемесячный расход на API модели, он зависит от числа запросов и платится напрямую провайдеру.",
        },
        {
            type: "table",
            head: ["Решение", "Разовая цена", "Срок", "Расход на API в месяц"],
            rows: [
                ["AI-пилот (одна задача)", "от 18 млн сум", "3–4 недели", "300 000 – 1,2 млн сум"],
                ["AI-стандарт (готово к продуктиву)", "от 45 млн сум", "6–10 недель", "1,5–4 млн сум"],
                ["AI-агент (общение с клиентом)", "от 15 млн сум", "3–4 недели", "250 000 – 900 000 сум"],
                ["Интеграция ИИ в текущую систему", "от 25 млн сум", "4–8 недель", "1–10 млн сум"],
                ["Пилот computer vision", "от 45 млн сум", "6–8 недель", "камеры и сервер отдельно"],
            ],
        },
        {
            type: "p",
            text:
                "Стоит заранее знать, что в смету не входит: оплата API считается отдельно и ежемесячно, а в проектах computer vision камеры и сервер покупаются отдельно. Если модель разворачивается на вашем сервере, платы за API нет, зато появляются расходы на оборудование.",
        },

        { type: "h2", text: "Как считается окупаемость — открытая формула" },
        {
            type: "p",
            text:
                "Отдача AI-проекта складывается из двух источников: сэкономленного времени и непотерянных денег. И то и другое можно посчитать заранее, нужно лишь подставить свои цифры.",
        },
        {
            type: "ol",
            items: [
                "Сколько раз в месяц повторяется задача? Например, входящих документов — 900 в месяц.",
                "Сколько времени уходит на один документ? Например, 6 минут — это 90 часов в месяц.",
                "Сколько стоит час сотрудника? С зарплатой и налогами, например, 45 000 сум.",
                "Какую долю задачи закроет модель? Реалистичный ориентир — 60–75 процентов, а не 100.",
                "Считаем экономию: 90 часов × 45 000 сум × 0,65 = около 2,6 млн сум в месяц.",
            ],
        },
        {
            type: "p",
            text:
                "Если в этом примере расход на API составит 800 000 сум, чистая экономия — около 1,8 млн сум в месяц. Пилот за 18 млн сум окупается примерно за 10 месяцев. Если половину расходов компенсирует государственная программа, срок сокращается до пяти месяцев.",
        },
        {
            type: "p",
            text:
                "Второй источник — непотерянные деньги: клиент, ушедший из-за долгого ответа, штраф за ошибку в документе, товар, зависший на складе. Такие суммы обычно крупнее сэкономленного времени, но для оценки нужна статистика прошлого года.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько стоит ничего не делать" },
        {
            type: "p",
            text:
                "Цена отсрочки не видна сразу: она не стоит отдельной строкой в отчёте. Но она есть.",
        },
        {
            type: "list",
            items: [
                "Квалифицированный сотрудник тратит три-четыре часа в день на копирование и поиск — это оплаченное время, которое не создаёт ценности.",
                "Часть входящих обращений остаётся без ответа или получает его поздно; клиент уходит к конкуренту, и этого никто не считает.",
                "Решения принимаются по ощущениям: сколько товара закупить, на какого лида потратить время. Цена такой ошибки вычитается прямо из маржи.",
                "Программы господдержки ограничены по времени: опоздавшие внедряют за полную стоимость.",
            ],
        },

        { type: "h2", text: "Риски: галлюцинации, точность и ежемесячный счёт" },
        {
            type: "p",
            text:
                "Об ИИ нужно говорить честно, иначе первая неудача убьёт доверие ко всему направлению. Языковые модели галлюцинируют — то есть уверенным тоном выдают неверный ответ. Это не дефект конкретного продукта, а свойство технологии.",
        },
        {
            type: "list",
            items: [
                "Главный способ борьбы с галлюцинациями — отвечать только по вашим документам и показывать в каждом ответе источник и номер страницы. Ответ без источника показываться не должен.",
                "В computer vision не бывает 100 процентов точности. При хорошем освещении и правильном ракурсе это обычно 90–97 процентов, в сложных условиях — темнота, перекрытие объектов — показатель падает до 75–90 процентов.",
                "Ежемесячный расход на API зависит от числа запросов и может расти. В системе обязательно ставятся лимиты и оповещения, иначе однажды счёт окажется неприятным сюрпризом.",
                "Персональные данные не должны уходить в облачную модель. Либо применяется маскирование, либо модель работает на вашем сервере.",
                "При изменении условий качество модели падает: новый тип упаковки, сдвиг ракурса камеры, обновление ассортимента. Поэтому дообучение планируется заранее.",
            ],
        },
        {
            type: "p",
            text:
                "Отдельно стоит сказать: ИИ не заменяет сотрудника целиком. Он забирает повторяющуюся часть, а решение остаётся за человеком. Юридическое заключение, финансовое утверждение и спорный разговор с клиентом требуют ответственности, а ответственность на модель не переложить.",
        },

        { type: "h2", text: "Когда ИИ не нужен" },
        {
            type: "p",
            text:
                "Возможно, это самый полезный раздел статьи. В перечисленных ниже случаях проект начинать не стоит.",
        },
        {
            type: "list",
            items: [
                "Данных нет или они не систематизированы. Сначала наладьте CRM или складской учёт, потом думайте об ИИ.",
                "Задача не повторяется. Автоматизировать работу, которая выполняется пять раз в месяц, дороже, чем делать её руками.",
                "Сам процесс сломан. Автоматизация беспорядка лишь ускоряет его, а не исправляет.",
                "Цена ошибки крайне высока, а механизма проверки нет. Медицинский диагноз или финальное юридическое заключение — как раз такие случаи.",
                "Бюджета хватает только на разовую оплату. Без денег на API и поддержку система остановится через два-три месяца.",
            ],
        },

        { type: "h2", text: "Первые 90 дней: практические шаги" },
        {
            type: "ol",
            items: [
                "Выберите одну задачу — самую повторяющуюся и самую измеримую. Не берите три сразу.",
                "Зафиксируйте текущий показатель: сколько раз в месяц, сколько времени, сколько ошибок. Это будет база для сравнения.",
                "Соберите и приведите в порядок данные. Этот этап самый долгий, и именно он определяет результат.",
                "Сделайте пилот на 3–4 недели. Критерий успеха запишите заранее: например, 60 процентов вопросов закрываются без человека.",
                "Измерьте и сравните. Если пилот не дотянул до критерия — остановитесь: потери ограничены 18 млн сум, а не сотнями миллионов.",
                "Если результат есть — масштабируйте и проверьте условия государственной компенсации по официальному источнику на тот момент.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "quote",
            text:
                "AI-проект начинается не с выбора модели, а с одной измеримой задачи. Польза, которую нельзя измерить, пользой не считается.",
        },
    ],

    faq: [
        {
            q: "Сколько стоит внедрение искусственного интеллекта в Узбекистане?",
            a: "В Innobek AI-пилот начинается от 18 000 000 сум — это решение одной задачи с обработкой до 500 документов. Готовый к продуктиву стандартный пакет — от 45 000 000 сум. AI-агент для общения с клиентами — от 15 000 000 сум, подключение ИИ к текущей CRM или 1С — от 25 000 000 сум. Это разовая оплата, API модели считается отдельно.",
        },
        {
            q: "Какой будет ежемесячный расход и из чего он складывается?",
            a: "Основная часть ежемесячных затрат — оплата API модели, и она зависит от числа запросов. При небольшом объёме, то есть 200–500 запросов в день, это примерно 300 000 – 1 200 000 сум. При среднем объёме — 1 500 000 – 4 000 000 сум. Деньги идут напрямую провайдеру. На пилоте реальный объём замеряется, и вы получаете точную цифру.",
        },
        {
            q: "Государство действительно компенсирует расходы на ИИ?",
            a: "Объявлена программа ИИ-партнёр для 10 000 предприятий, в рамках которой бизнесу компенсируют 50 процентов расходов на внедрение искусственного интеллекта. Кроме того, в бюджете на направление ИИ заложено 100 млрд сум ежегодно. Но условия и порядок подачи заявок будут уточняться, поэтому бюджет правильнее строить на собственной окупаемости проекта, а не на компенсации.",
        },
        {
            q: "За какой срок окупается AI-проект?",
            a: "Всё зависит от частоты повторений. Если в месяц обрабатывается 900 документов и на каждый уходит 6 минут, пилот обычно выходит в ноль за 8–12 месяцев. При компенсации половины расходов срок сокращается вдвое. Если повторений мало, окупаемость растягивается. Универсального срока нет — подставьте свои цифры в формулу из пяти шагов выше.",
        },
        {
            q: "Что будет, если ИИ ответит неверно?",
            a: "Языковые модели галлюцинируют: уверенным тоном выдают неправильный ответ. Основной способ защиты — разрешить модели отвечать только по вашим документам и показывать в каждом ответе источник и номер страницы. Если источник не найден, система передаёт вопрос человеку. Решения, требующие ответственности, в любом случае остаются за сотрудником.",
        },
        {
            q: "Когда ИИ не нужен?",
            a: "Если данные не собраны и не систематизированы, сначала наладьте учёт. Если задача выполняется несколько раз в месяц, автоматизация обойдётся дороже ручной работы. Если сломан сам процесс, ИИ лишь ускорит беспорядок. Не начинайте и там, где цена ошибки крайне высока, а проверить результат нечем. И не начинайте, если бюджета хватает только на разработку.",
        },
        {
            q: "Останутся ли мои данные конфиденциальными?",
            a: "Этот вопрос решается в начале проекта. Есть три варианта: маскировать персональные данные перед отправкой в модель, выносить в облако только неконфиденциальную часть или разворачивать модель целиком на своём сервере. В третьем случае оплаты API нет, но появляются расходы на оборудование и обслуживание. Журнал аудита нужен в любом из трёх вариантов.",
        },
    ],

    cta: {
        h: "Бесплатно проверим, даст ли вам ИИ пользу",
        p:
            "Разберём ваши процессы, покажем одну задачу, где искусственный интеллект даст измеримый результат, и честно скажем, где не даст. Затем назовём цену, срок и ориентир по ежемесячному расходу.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/ai-joriy-etish-cover.webp",
            alt: "Владелец малого бизнеса смотрит на ноутбуке сводку заявок, подготовленную ИИ-помощником",
            caption: "AI-проект начинается не с большого бюджета, а с одной измеримой задачи",
            prompt:
                "Small-business owner at a laptop where an AI assistant panel summarises incoming orders and flags three priorities; warm realistic office scene, subtle blue glow from the screen, documentary photography style, no readable text or logos, 16:9",
        },
        {
            src: "/assets/img/blog/ai-joriy-etish-kirish-nuqtalari.webp",
            alt: "Три недорогие точки входа во внедрение ИИ, показанные в виде карточек",
            caption: "Три точки входа: разбор документов, повторяющиеся вопросы и прогноз",
            prompt:
                "Three entry-point cards for AI adoption: document and request parsing, repetitive customer questions, forecasting (stock, demand, lead scoring); each card shows required data volume, typical timeline and budget band as blank meter bars; clean flat cards, blue and violet accents, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/ai-joriy-etish-tayyorgarlik.webp",
            alt: "Воронка готовности AI-проекта: данные, очистка, пилот, измерение и масштабирование",
            caption: "Самая частая ошибка случается на этапе очистки данных",
            prompt:
                "Readiness funnel diagram: data collected to data cleaned to pilot on one process to measurement to scale; each stage narrowing, with a warning marker at the data-cleaning stage; minimal line infographic, blue gradient with one amber marker, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/projects/neurotagline.webp",
            alt: "Проект Neurotagline — интерфейс продукта на базе искусственного интеллекта на экране",
            caption: "Neurotagline — проект Innobek в AI-направлении",
        },
    ],

    relatedServices: ["sun-iy-intellekt", "ai-integratsiya", "ai-agent"],
    relatedPosts: ["ai-chatbot-yoki-jonli-operator", "computer-vision-ombor-va-dokonda"],
};

const content = { uz, ru };

export default content;
